module.exports = __webpack_public_path__ + "img/youtube-pulse-event-2018.74d3b06d.jpg";